import React, { useEffect, useState } from 'react';
import { StagingPasswordPage } from '../../pages/StagingPasswordPage';

interface StagingGuardProps {
  children: React.ReactNode;
}

export const StagingGuard: React.FC<StagingGuardProps> = ({ children }) => {
  const [hasAccess, setHasAccess] = useState<boolean | null>(null);

  useEffect(() => {
    const checkStagingAccess = () => {
      const isStaging = window.location.hostname === 'staging.learnwithodyssey.com';
      
      if (!isStaging) {
        setHasAccess(true);
        return;
      }

      const stagingAccess = sessionStorage.getItem('stagingAccess');
      setHasAccess(stagingAccess === 'granted');
    };

    checkStagingAccess();
    
    const handleStorageChange = () => {
      checkStagingAccess();
    };

    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  if (hasAccess === null) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: 'white',
        color: 'var(--neutral-700)',
        fontSize: '1.2rem'
      }}>
        Loading...
      </div>
    );
  }

  if (!hasAccess) {
    return <StagingPasswordPage />;
  }

  return <>{children}</>;
};